enum ActionStatus {
    Hidden = 'hidden',
    InProgress = 'inProgress',
    Success = 'success',
    Error = 'error',
}

export default ActionStatus;
